<template>
    <div class='recent-videos'>
        <div class='container'>
            <h2 class='title'>{{ $root.t('Mais Recentes') }}</h2>
            <div class='title-bar'></div>
            <carousel
                :perPage="1"
                :perPageCustom="[[768, 2]]"
                paginationActiveColor="#FFB612"
                paginationColor="gray"
            >
                <slide class="video-wrapper" v-for="video in recentVideos" :key="video.id">
                    <router-link :to="`/treino/${video.parent_slug}/video/${video.slug}`">
                        <img @click="gaEvent(video)" :src="getYoutubeThumbnail(video)" class="recent-videos__image" />
                    </router-link>
                    <p class="recent-videos__description" >{{video.description}}</p>
                </slide>
            </carousel>
        </div>
     </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { mapGetters } from 'vuex'

export default {
    components: {
        Carousel,
        Slide
    },
    computed : {
        ...mapGetters([
            'recentVideos',
            'theme'
        ]),
    },
    methods: {
        getYoutubeThumbnail (video) {
            return `https://img.youtube.com/vi/${video.videoId.params.v}/hqdefault.jpg`
        },
        gaEvent (video) {
            this.$gtm.trackEvent({
                event: 'gaEvent',
                eventCategory: `treine-em-casa-${this.theme}`,
                eventAction: 'mais-recentes',
                eventLabel: video.subtitle,
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .recent-videos {
        padding: 20px;

        &__image {
            cursor: pointer;
        }
    }
    .title {
        margin: 0;
        font-size: 32px;
    }
    .title-bar {
        width: 64px;
        height: 8px;
        background-color: #FFB612;
        margin: 12px 0 30px;
    }
    .video-wrapper {
        padding: 0 10px;
    }
    iframe {
        width: 100%;
        max-width: 450px;
    }

</style>
